export default __webpack_public_path__ + "images/OL.0eeafed.png";